export const BACKEND_BASEURL = (process.env.REACT_APP_BACKEND_BASEURL || 'http://localhost:3001').replace(/\/+$/, '');

export const withBase = (path = '') => {
  if (!path) return BACKEND_BASEURL;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/')) return `${BACKEND_BASEURL}${path}`;
  return `${BACKEND_BASEURL}/${path}`;
};